import { Col, Modal, Row, Tooltip } from 'antd';
import { TiTick } from 'react-icons/ti';
import { RxCross2 } from 'react-icons/rx';
import React, { useEffect } from 'react';
import { FaEye } from 'react-icons/fa';

const ViewPlanModal = ({ currentPlan, openViewModal, onViewCancel }) => {
  // useEffect(() => {
  //   console.log(currentPlan, '--------------------------inside ViewcurrentPlan');
  // }, [currentPlan]);

  return (
    <div>
      <Modal
        style={{ top: 20 }}
        title={currentPlan?.name}
        footer={null}
        open={openViewModal}
        onOk={onViewCancel}
        onCancel={onViewCancel}
      >
        <Row gutter={20}>
          {currentPlan?.features.map((feature, index) => (
            <Col key={index} span={12}>
              <div key={index} className="my-2 border p-2">
                <div className="flex items-center justify-between w-full flex-wrap">
                  <p className={`font-semibold text-md mb-0 ${feature.toDisplay ? `text-primary` : `text-gray-700`}`}>
                    {feature.type_name}
                  </p>
                  {feature.toDisplay ? (
                    <Tooltip title={`Displayed on front end`}>
                      <FaEye color="green" />
                    </Tooltip>
                  ) : (
                    <Tooltip title={`Not displayed on front end`}>
                      <FaEye color="gray" />
                    </Tooltip>
                  )}
                </div>
                {feature.features_to_show.map((item, i) => (
                  <div key={i} className="flex items-center justify-between flex-wrap">
                    <span>{item.feature_name}</span>
                    <span>
                      {item.isEnabled ? (
                        <span className="bg-green-300 w-4 h-4 rounded-full">
                          <TiTick style={{ color: feature.toDisplay ? `green` : `gray` }} />
                        </span>
                      ) : (
                        <span className="bg-red-300 w-4 h-4 rounded-full">
                          <RxCross2 style={{ color: feature.toDisplay ? `red` : `gray` }} />
                        </span>
                      )}
                    </span>
                  </div>
                ))}
                <div className="flex items-center justify-between w-full">
                  <p className={`font-semibold text-md mb-0 ${feature.toDisplay ? `text-primary` : `text-gray-700`}`}>
                    {`${feature.type_name.toLowerCase()} plan price:`}
                  </p>
                  <p
                    className={`font-semibold text-md mb-0 ${feature.toDisplay ? `text-primary` : `text-gray-700`}`}
                  >{`₹ ${feature.type_price}`}</p>
                </div>
              </div>
            </Col>
          ))}
        </Row>
        {/* <div className="my-2">
          <div className="flex items-center justify-between">
            <p className="mb-0 font-semibold text-primary">Coupon code</p>
            <p className="mb-0 font-semibold text-primary">Percentage discount</p>
          </div>
          {currentPlan?.discount_codes.map((item, index) => (
            <div key={index} className="flex items-center justify-between">
              <p className="mb-0 text-sm">{item.discount_coupon}</p>
              <p className="mb-0 text-sm">{item.percentage_discount}</p>
            </div>
          ))}
        </div> */}
      </Modal>
    </div>
  );
};

export default ViewPlanModal;
